// PollEditor — Optional poll attached to a published analysis (PRO only).
import React from "react";
import { X as XIcon, Crown } from "lucide-react";
import { tFases } from "../../../i18n/shadow-fases";

export const PollEditor = ({
  isPro, lang,
  pollOn, setPollOn,
  pollQuestion, setPollQuestion,
  pollOptions, setPollOptions,
  onProGate,
}) => {
  const onToggle = (e) => {
    if (!isPro) { onProGate("chars"); return; }
    setPollOn(e.target.checked);
  };

  const updateOption = (idx, value) => {
    const next = [...pollOptions];
    next[idx] = value.slice(0, 60);
    setPollOptions(next);
  };

  return (
    <div className="mt-4 rounded-2xl border border-white/10 bg-white/[0.02] p-3">
      <label className="flex cursor-pointer items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <span className="text-[10px] font-black uppercase tracking-[0.22em] text-white/55">
            📊 {tFases(lang, "publish_poll_label")}
          </span>
          {!isPro && (
            <span className="inline-flex items-center gap-1 rounded-full border border-amber-400/40 bg-amber-400/10 px-2 py-0.5 text-[9px] font-bold uppercase tracking-[0.15em] text-amber-200">
              <Crown className="h-2.5 w-2.5" /> {tFases(lang, "publish_poll_pro")}
            </span>
          )}
        </div>
        <input
          type="checkbox"
          checked={pollOn}
          disabled={!isPro}
          onChange={onToggle}
          data-testid="shadow-publish-poll-toggle"
          className="h-4 w-4 cursor-pointer accent-orange-500 disabled:cursor-not-allowed"
        />
      </label>
      {pollOn && isPro && (
        <div className="mt-3 space-y-2">
          <input
            value={pollQuestion}
            onChange={(e) => setPollQuestion(e.target.value.slice(0, 140))}
            placeholder={tFases(lang, "publish_poll_q_ph")}
            maxLength={140}
            data-testid="shadow-publish-poll-question"
            className="w-full rounded-xl border border-white/10 bg-white/[0.04] px-3 py-2 text-sm outline-none focus:border-orange-400/50"
          />
          {pollOptions.map((opt, idx) => (
            <div key={idx} className="flex items-center gap-2">
              <input
                value={opt}
                onChange={(e) => updateOption(idx, e.target.value)}
                placeholder={tFases(lang, "publish_poll_opt_ph", { n: idx + 1 })}
                maxLength={60}
                data-testid={`shadow-publish-poll-option-${idx}`}
                className="flex-1 rounded-xl border border-white/10 bg-white/[0.04] px-3 py-2 text-sm outline-none focus:border-orange-400/50"
              />
              {pollOptions.length > 2 && (
                <button
                  type="button"
                  onClick={() => setPollOptions(pollOptions.filter((_, i) => i !== idx))}
                  className="rounded-full border border-white/10 p-1 text-white/55 hover:border-rose-400/40 hover:text-rose-300"
                  aria-label="Eliminar opción"
                  data-testid={`shadow-publish-poll-remove-${idx}`}
                >
                  <XIcon className="h-3 w-3" />
                </button>
              )}
            </div>
          ))}
          {pollOptions.length < 4 && (
            <button
              type="button"
              onClick={() => setPollOptions([...pollOptions, ""])}
              data-testid="shadow-publish-poll-add"
              className="text-[10px] font-bold uppercase tracking-[0.18em] text-white/55 transition-colors hover:text-orange-300"
            >
              {tFases(lang, "publish_poll_add", { n: pollOptions.length })}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default PollEditor;
